import { dashboardCookieName } from '../dashboard-cookie'

/**
 * This can be removed after we completely switch to the new dashboard that
 * was introduced in the value reporting effort.
 */
export function DashboardToggleService(
  $routeParams: {
    readonly orgUuid: string
  },
  $routeSegment: {
    readonly chain: LegacyRouteSegmentProvider['chain']
  },
  $window: {
    readonly location: {
      hash: string
    }
  },
  $cookies: {
    readonly remove: LegacyCookiesService['remove']
  }
) {
  'ngInject'

  return {
    /**
     * Redirecting is enough here because the route resolver will
     * set the cookie so that the new dashboard will be shown by
     * default and then it will redirect the route to this
     * main dashboard
     */
    enableNewDashboard: () => {
      $window.location.hash = `/${$routeParams.orgUuid}/value-reporting`
    },
    onBackToOldDashboard: () => {
      $cookies.remove(dashboardCookieName, { path: '/Contrast' })
      $routeSegment.chain[0].reload()
    }
  }
}
